export default __webpack_public_path__ + "static/media/hills.52b55a06.jpeg";